import { CommentKindEnum } from "../../enums/comment-kind.enum";
import { ChangeStatusModel } from "./change-status-model";

export class PerformerGroupModel extends ChangeStatusModel {
    performerGroupId: number;
    comment: string;

    constructor(requestId: number, newStatusId: number, performerUserGroupId: number, comment: string, commentKind: CommentKindEnum = CommentKindEnum.internal){
        super(requestId, newStatusId);
        this.requestId = requestId;
        this.newStatusId = newStatusId;
        this.performerGroupId = performerUserGroupId;
        this.comment = comment;
        this.commentKind = commentKind;
    }
}